import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import type { FormValueControl } from '@angular/forms/signals';
import { TranslatePipe } from '@ngx-translate/core';
import { UiFieldControl } from '../../../basics/ui-field-control';
import { IconUIComponent } from '../../atoms/icon/icon.component';
import { SliderFieldComponent } from '../../atoms/slider-field/slider-field.component';

const DEFAULT_SLIDER_MAX = 100;

@Component({
  selector: 'fr8bot-ui-slider-with-controls-field',
  imports: [SliderFieldComponent, IconUIComponent, TranslatePipe],
  templateUrl: './slider-with-controls-field.component.html',
  styleUrl: './slider-with-controls-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderWithControlsFieldComponent
  extends UiFieldControl
  implements FormValueControl<number | null>
{
  readonly value = model<number | null>(null);

  // Not `min`/`max`: `[formField]` owns those input names.
  readonly minValue = input(0);
  readonly maxValue = input(DEFAULT_SLIDER_MAX);
  readonly step = input(1);
  readonly defaultValue = input(0);

  private readonly position = computed(() => this.value() ?? this.defaultValue());

  protected stepBy(direction: 1 | -1): void {
    const next = this.position() + direction * this.step();

    this.value.set(Math.min(Math.max(next, this.minValue()), this.maxValue()));
    this.touch.emit();
  }
}
